<template>
  <fieldset class="-space-y-px rounded-lg bg-white">
    <label
      v-for="item in items"
      :key="item.label"
      class="group flex gap-x-4 border border-gray-200 p-4 first:rounded-tl-md first:rounded-tr-md last:rounded-br-md last:rounded-bl-md focus:outline-hidden has-checked:relative hover:bg-gray-50 transition-colors duration-200 cursor-pointer"
      :class="{ 'bg-primary-50': item.modelValue === modelValue }"
    >
      <input
        v-show="!hideRadioButton"
        v-model="modelValue"
        type="radio"
        :name="inputId"
        :value="item.modelValue"
        :disabled="item.disabled"
       
        class="relative mt-1 size-5 shrink-0 appearance-none rounded-full border border-gray-300 bg-white before:absolute before:inset-0.75 before:rounded-full before:bg-white not-checked:before:hidden checked:border-2 checked:border-secondary checked:bg-secondary focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-secondary disabled:border-gray-300 disabled:bg-gray-100 disabled:before:bg-gray-400 forced-colors:appearance-auto cursor-pointer forced-colors:before:hidden"
      >

      <span class="block space-y-1 w-full">
        <span class="flex gap-2 justify-between">
          <span class="flex gap-2 items-center flex-wrap">
            <span class="font-semibold text-base/6">
              {{ item.label }}
            </span>
            <TBadge
              v-if="item?.badge"
              variant="highlight"
              :size="badgeSize"
            >{{ item.badge }}</TBadge>
          </span>
          <span class="font-semibold text-sm/6 whitespace-nowrap">
            {{ item.value }}
          </span>
        </span>

        <span
          v-if="item.sublabel"
          class="block text-sm font-semibold"
        >{{ item.sublabel }}</span>
        <span
          v-if="item.description"
          class="block text-sm text-gray-500"
        >{{ item.description }}</span>
      </span>
    </label>
  </fieldset>
</template>

<script setup lang="ts" generic="T">
import type { RadioCardListItem } from './types'
import type { BadgeSize } from '~/components/_tailwind/badge/types'

withDefaults(defineProps<{
  items: RadioCardListItem<T>[]
  badgeSize?: BadgeSize
  hideRadioButton?: boolean
}>(), {
  badgeSize: 'md',
})

const modelValue = defineModel<T>({ required: true })

const inputId = useId()
</script>
